/* istanbul ignore file */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type HistoryBubbleTableDataObject } from '../types'

export interface ExportBubbleKpiDetailsState {
  isLoading: boolean
  error: string | undefined
  httpStatus: number
  exportBubbleKpiDetails: HistoryBubbleTableDataObject | undefined
}

// Initial state of the slice
const initialState: ExportBubbleKpiDetailsState = {
  isLoading: true,
  error: undefined,
  httpStatus: 0,
  exportBubbleKpiDetails: undefined
}

// Slice to return from action
export const exportBubbleKpiDetailsSlice = createSlice({
  name: 'exportBubbleKpiDetails',
  initialState,
  reducers: {
    exportBubbleKpiDetailsLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        exportBubbleKpiDetails: undefined,
        httpStatus: 0
      }
    },
    exportBubbleKpiDetailsUpdateAction: (state, action: PayloadAction<{ data: HistoryBubbleTableDataObject, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        exportBubbleKpiDetails: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    exportBubbleKpiDetailsErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        exportBubbleKpiDetails: undefined,
        httpStatus: action.payload.httpStatus
      }
    },
    // istanbul ignore next
    exportBubbleKpiDetailsResetAction: () => {
      return {
        isLoading: false,
        error: undefined,
        exportBubbleKpiDetails: undefined,
        httpStatus: 0
      }
    }
  }
})

// Actions to export
export const {
  exportBubbleKpiDetailsLoadingAction,
  exportBubbleKpiDetailsUpdateAction,
  exportBubbleKpiDetailsErrorAction,
  exportBubbleKpiDetailsResetAction
} = exportBubbleKpiDetailsSlice.actions

export default exportBubbleKpiDetailsSlice.reducer
